import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_2 = {
  class: "btn btn-success",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoRequiredFields = _resolveComponent("InfoRequiredFields")!
  const _component_FormControlInput = _resolveComponent("FormControlInput")!
  const _component_FormControlAttributes = _resolveComponent("FormControlAttributes")!
  const _component_FormControlTextarea = _resolveComponent("FormControlTextarea")!
  const _component_Form = _resolveComponent("Form")!
  const _component_QuestionSuggestions = _resolveComponent("QuestionSuggestions")!
  const _component_WdwDynbox = _resolveComponent("WdwDynbox")!

  return (_ctx.askus.new_questions)
    ? (_openBlock(), _createBlock(_component_WdwDynbox, {
        key: 0,
        title: _ctx.domainStore.translate('askus.create.title'),
        minimize: false,
        config: { showControls: true }
      }, {
        default: _withCtx(() => [
          (_ctx.data.errors['all'] != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.data.errors['all']), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_InfoRequiredFields),
          _createVNode(_component_Form, { onSubmit: _ctx.submitQuestion }, {
            default: _withCtx(() => [
              _createVNode(_component_FormControlInput, {
                label: _ctx.domainStore.translate('askus.create.form.title-label'),
                name: "title",
                error: _ctx.domainStore.translate('askus.create.message.generic-field-required-error'),
                required: true
              }, null, 8, ["label", "error"]),
              _createVNode(_component_FormControlAttributes, {
                elementPrefixId: "wdw-askus-question-form",
                onValidate: _ctx.onValidatedFormField,
                requiredIfResults: _ctx.data.requiredIfResult,
                visibleIfResults: _ctx.data.visibleIfResult,
                fields: _ctx.askus.attributes,
                serverErrors: _ctx.data.errors
              }, null, 8, ["onValidate", "requiredIfResults", "visibleIfResults", "fields", "serverErrors"]),
              _createVNode(_component_FormControlTextarea, {
                watchChange: _ctx.askus.has_recommendations,
                onChange: _ctx.setSuggestionsText,
                label: _ctx.domainStore.translate('askus.create.form.content-label'),
                name: "content",
                error: _ctx.domainStore.translate('askus.create.message.generic-field-required-error'),
                required: true
              }, null, 8, ["watchChange", "onChange", "label", "error"]),
              _createElementVNode("button", _hoisted_2, _toDisplayString(_ctx.domainStore.translate('askus.create.form.submit')), 1),
              _createElementVNode("button", {
                class: "btn btn-default",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, _toDisplayString(_ctx.domainStore.translate('askus.create.form.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _createVNode(_component_QuestionSuggestions, {
            text: _ctx.suggestionsText,
            onOpenQuestion: _ctx.openQuestion
          }, null, 8, ["text", "onOpenQuestion"])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}